import { supabase } from './supabase.js';

export async function signUpWithEmail({ email, password, fullName, phone }) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: { full_name: fullName, phone },
      emailRedirectTo: `${window.location.origin}/`,
    },
  });
  return { data, error };
}

export async function signInWithEmail({ email, password }) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  return { data, error };
}

export async function signInWithGoogle() {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: `${window.location.origin}/`,
      // Always show Google's account chooser so a user who signed out can
      // pick a different account instead of being silently logged back in
      // with the previously-used one.
      queryParams: { prompt: 'select_account' },
    },
  });
  return { data, error };
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  return { error };
}

export async function getSession() {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
}

// Identity for anything that writes a user_id. Reads (and silently refreshes)
// the same token the request is actually sent with, so it can never disagree
// with auth.uid() inside an RLS policy. supabase.auth.getUser() must NOT be
// used for this: it is a network round-trip that returns null on any failure,
// which downgrades the write to a guest row and trips RLS.
export async function getSessionUser() {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.user ?? null;
}

export async function getProfile(userId) {
  const { data, error } = await supabase
    .from('profiles')
    .select('id, full_name, phone, is_admin')
    .eq('id', userId)
    .single();
  return { data, error };
}

export async function updateProfile(userId, { full_name, phone }) {
  const { data, error } = await supabase
    .from('profiles')
    .update({ full_name, phone, updated_at: new Date().toISOString() })
    .eq('id', userId)
    .select()
    .single();
  return { data, error };
}

export function onAuthChange(callback) {
  const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
    callback(session);
  });
  return () => subscription.unsubscribe();
}
